<template>
  <div :class="radioGroupClasses">
    <themed-radio
      v-for="option in normalizedOptions"
      :key="option.value"
      :name="name"
      :value="option.value"
      :checked="value === option.value"
      :label="option.label"
      :disabled="disabled || option.disabled"
      @input="handleInput"
    />
  </div>
</template>

<script>
import ThemedRadio from './ThemedRadio.vue';

export default {
  name: 'ThemedRadioGroup',
  
  components: {
    ThemedRadio
  },
  
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    options: {
      type: Array,
      required: true,
      validator: (options) => {
        return options.every(opt => {
          if (typeof opt === 'object') {
            return Object.prototype.hasOwnProperty.call(opt, 'value') && Object.prototype.hasOwnProperty.call(opt, 'label');
          }
          return typeof opt === 'string' || typeof opt === 'number';
        });
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: 'vertical',
      validator: (v) => ['vertical', 'horizontal', 'inline'].includes(v)
    }
  },
  
  computed: {
    radioGroupClasses() {
      return [
        'themed-radio-group',
        `themed-radio-group--${this.layout}`
      ];
    },
    
    normalizedOptions() {
      return this.options.map(option => {
        if (typeof option === 'object') {
          return {
            value: option.value,
            label: option.label,
            disabled: option.disabled || false
          };
        }
        // If option is a string or number, use it as both value and label
        return {
          value: option,
          label: option,
          disabled: false
        };
      });
    }
  },
  
  methods: {
    handleInput(value) {
      this.$emit('input', value);
    }
  }
};
</script>
